export const emailValidation = (
  value: string,
  message: string,
  noRequired?: boolean
): any => {
  if (noRequired && !value) {
    return true;
  }
  const regex = /^[\w.-]+@[\w-]+(\.[\w-]+)*\.[A-Za-z]{2,}$/;
  return regex.test(value) || message;
};
